/* tslint:disable */
/* eslint-disable */
/**
 * re-order
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SerialItem
 */
export interface SerialItem {
    /**
     * 
     * @type {string}
     * @memberof SerialItem
     */
    serial?: string;
    /**
     * 
     * @type {string}
     * @memberof SerialItem
     */
    lot?: string;
    /**
     * 
     * @type {number}
     * @memberof SerialItem
     */
    quantityBooked?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SerialItem
     */
    isSelected?: boolean;
}

/**
 * Check if a given object implements the SerialItem interface.
 */
export function instanceOfSerialItem(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SerialItemFromJSON(json: any): SerialItem {
    return SerialItemFromJSONTyped(json, false);
}

export function SerialItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SerialItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'serial': !exists(json, 'serial') ? undefined : json['serial'],
        'lot': !exists(json, 'lot') ? undefined : json['lot'],
        'quantityBooked': !exists(json, 'quantityBooked') ? undefined : json['quantityBooked'],
        'isSelected': !exists(json, 'isSelected') ? undefined : json['isSelected'],
    };
}

export function SerialItemToJSON(value?: SerialItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'serial': value.serial,
        'lot': value.lot,
        'quantityBooked': value.quantityBooked,
        'isSelected': value.isSelected,
    };
}

